import React, { useMemo } from 'react';
import { Button, mergeClasses, Text } from '@fluentui/react-components';
import { ChevronLeft20Regular, ChevronRight20Regular } from '@fluentui/react-icons';
import { useDataSource } from '@bingads-webui-react/data-source';

import { I18n } from '../types';
import { usePaginatorStyles } from './paginator-styles';

interface PaginatorProps {
  i18n: I18n;
  className?: string;
}

export const Paginator: React.FC<PaginatorProps> = ({ i18n, className }) => {
  const classes = usePaginatorStyles();

  const {
    currentPage,
    totalPages,
    isLoading,
    prevPage,
    nextPage,
  } = useDataSource();

  const label = useMemo(
    () => i18n.getString(_TL_('{{currentPage}} of {{totalPages}}'), { currentPage, totalPages }),
    [currentPage, i18n, totalPages],
  );

  return (
    <div className={mergeClasses('entity-selector-paginator', classes.root, className)}>
      <Text>
        {label}
      </Text>
      <Button
        appearance="subtle"
        icon={<ChevronLeft20Regular />}
        disabled={isLoading || currentPage === 1}
        onClick={prevPage}
      />
      <Button
        appearance="subtle"
        icon={<ChevronRight20Regular />}
        disabled={isLoading || currentPage === totalPages}
        onClick={nextPage}
      />
    </div>
  );
};
